//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_mesh_swarm } from "./swarm_pb.js";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file dxos/mesh/rtc.proto.
 */
export const file_dxos_mesh_rtc = /*@__PURE__*/ fileDesc("ChNkeG9zL21lc2gvcnRjLnByb3RvEg1keG9zLm1lc2gucnRjIowBChFDb25uZWN0aW9uUmVxdWVzdBImCghwcm94eV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSEQoJaW5pdGlhdG9yGAIgASgIEhcKD3JlbW90ZV9wZWVyX2tleRgDIAEoCRIUCgxvd25fcGVlcl9rZXkYBCABKAkSDQoFdG9waWMYBSABKAkiYAoNU2lnbmFsUmVxdWVzdBImCghwcm94eV9pZBgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSJwoGc2lnbmFsGAIgASgLMhcuZHhvcy5tZXNoLnN3YXJtLlNpZ25hbCI2CgxDbG9zZVJlcXVlc3QSJgoIcHJveHlfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5IjgKDkRldGFpbHNSZXF1ZXN0EiYKCHByb3h5X2lkGAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleSIiCg9EZXRhaWxzUmVzcG9uc2USDwoHZGV0YWlscxgBIAEoCSI2CgxTdGF0c1JlcXVlc3QSJgoIcHJveHlfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5IjcKDVN0YXRzUmVzcG9uc2USJgoFc3RhdHMYASABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0YgZwcm90bzM", [file_dxos_keys, file_dxos_mesh_swarm, file_google_protobuf_struct]);
/**
 * Describes the message dxos.mesh.rtc.ConnectionRequest.
 * Use `create(ConnectionRequestSchema)` to create a new message.
 */
export const ConnectionRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 0);
/**
 * Describes the message dxos.mesh.rtc.SignalRequest.
 * Use `create(SignalRequestSchema)` to create a new message.
 */
export const SignalRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 1);
/**
 * Describes the message dxos.mesh.rtc.CloseRequest.
 * Use `create(CloseRequestSchema)` to create a new message.
 */
export const CloseRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 2);
/**
 * Describes the message dxos.mesh.rtc.DetailsRequest.
 * Use `create(DetailsRequestSchema)` to create a new message.
 */
export const DetailsRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 3);
/**
 * Describes the message dxos.mesh.rtc.DetailsResponse.
 * Use `create(DetailsResponseSchema)` to create a new message.
 */
export const DetailsResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 4);
/**
 * Describes the message dxos.mesh.rtc.StatsRequest.
 * Use `create(StatsRequestSchema)` to create a new message.
 */
export const StatsRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 5);
/**
 * Describes the message dxos.mesh.rtc.StatsResponse.
 * Use `create(StatsResponseSchema)` to create a new message.
 */
export const StatsResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_rtc, 6);
//# sourceMappingURL=rtc_pb.js.map